(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-row"] && !Shopify.designMode) return;
  try {
    (function productTile() {
    (function applyHeightIfMultilineTitles() {
      const MULTILINE_THRESHOLD = 1.5;

      function isTitleMultiline($title) {
        const lineHeight = parseFloat(getComputedStyle($title).lineHeight);
        const actualHeight = $title.offsetHeight;
        return actualHeight > lineHeight * MULTILINE_THRESHOLD;
      }

      function rowHasMultilineTitles($row) {
        const $titles = $row.querySelectorAll('.product-tile__content__title');
        const titles = Array.from($titles);
        return titles.some(isTitleMultiline);
      }

      function updateRowHeightClass($row) {
        const hasMultiline = rowHasMultilineTitles($row);
        $row.classList.toggle('product-row--has-multiline', hasMultiline);
      }

      function updateAllRowsHeightClasses() {
        const $rows = document.querySelectorAll('.product-row');
        const rows = Array.from($rows);
        rows.forEach(updateRowHeightClass);
      }

      updateAllRowsHeightClasses();
      window.addEventListener('resize', updateAllRowsHeightClasses);
    })();

    // function initializeTouchInteraction($tile) {
    //   const $wrapper = $tile.querySelector('.product-tile__img-wrapper');
    //   const $link = $wrapper.querySelector('a');

    //   let isImageRevealed = false;
    //   let resetTimerId = null;

    //   function revealHoverImage() {
    //     $tile.classList.add('is-touched');
    //     isImageRevealed = true;
    //   }

    //   function resetToDefaultImage() {
    //     clearResetTimer();
    //     $tile.classList.remove('is-touched');
    //     isImageRevealed = false;
    //   }

    //   function clearResetTimer() {
    //     if (resetTimerId) {
    //       clearTimeout(resetTimerId);
    //       resetTimerId = null;
    //     }
    //   }

    //   function scheduleReset() {
    //     clearResetTimer();
    //     resetTimerId = setTimeout(resetToDefaultImage, 3000);
    //   }

    //   function navigateToProduct() {
    //     window.location.href = $link.href;
    //   }

    //   function handleWrapperTouch(event) {
    //     event.preventDefault();

    //     if (!isImageRevealed) {
    //       event.stopPropagation();
    //       revealHoverImage();
    //       scheduleReset();
    //       return;
    //     }

    //     navigateToProduct();
    //   }

    //   function handleDocumentTouch(event) {
    //     const isTouchingOutsideTile = !$tile.contains(event.target);
    //     if (isTouchingOutsideTile && isImageRevealed) {
    //       clearResetTimer();
    //       resetToDefaultImage();
    //     }
    //   }

    //   $wrapper.addEventListener('touchend', handleWrapperTouch);
    //   document.addEventListener('touchstart', handleDocumentTouch);
    // }

    // function initializeAllTiles() {
    //   const $tiles = document.querySelectorAll('.product-tile');
    //   $tiles.forEach(initializeTouchInteraction);
    // }

    // initializeAllTiles();
  })();
  } catch(e) { console.error(e); }
})();

})();
